module.exports = __webpack_public_path__ + "static/media/money.b86e709b.svg";